export default __webpack_public_path__ + "static/moving-home-890de2271cfed067dc59bde9f81ab137.webp";